import * as React from "react";
import type { SVGProps } from "react";

interface RedFlagProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const RedFlag = ({ cancelled = false, ...props }: RedFlagProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFFBFB"
        d="M3.56 22.38a3.65 3.65 0 0 1-.68-5.12A3.44 3.44 0 0 1 5.3 16h.1l-.02-.15-.02-.05-.01-.07a7 7 0 0 0-.25-.6l-.53-1.07a5.8 5.8 0 0 1-.58-1.59A40 40 0 0 1 3.5 6.4c-.01-.54.21-1.06.61-1.42l4-3.6c.85-.78 2.2-.6 2.8.38l.25.4.32.49a9.5 9.5 0 0 0 1.2 1.5l.43.47.2.21.23-.07c.82-.23 1.95-.44 3.43-.64l.37-.05c.9-.11 1.7.42 2 1.23l.04.14.9-.08c.92-.1 1.74.5 1.97 1.36l.04.16.02.17.27 3.33c.02.3-.03.6-.14.86l-.3.73-.24.6-.26.74-.14.5-.36 1.48c-.13.49-.24.84-.37 1.17-.75 1.89-1.31 2.7-2.22 3.1-.19.09-.38.14-.58.16-1.65.15-3.16.2-4.52.17l-.59-.02a69 69 0 0 1-3-.22l-.4-.03.01.1c.02.75-.19 1.48-.62 2.09l-.14.18a3.65 3.65 0 0 1-5.15.4Z"
      />
      <path
        fill="#000"
        d="M4.03 21.8c-1.28-1.04-1.55-2.85-.57-4.07a2.77 2.77 0 0 1 2.76-.93l.06.02-.05-.46c-.05-.35-.1-.62-.15-.8l-.03-.08a8 8 0 0 0-.27-.66l-.2-.44-.34-.65a5.2 5.2 0 0 1-.52-1.4c-.25-1.33-.4-3.3-.47-5.96 0-.32.13-.63.36-.84l4-3.61a1.1 1.1 0 0 1 1.67.23l.37.6a13.3 13.3 0 0 0 1.47 1.9l.28.3.64.66.06.07.27-.1.37-.1.42-.11c.82-.2 1.9-.39 3.28-.57.8-.1 1.41.65 1.2 1.39l-.02.06.78-.07.96-.09a1.1 1.1 0 0 1 1.2 1l.27 3.34c.01.18-.02.35-.08.51l-.21.51a25 25 0 0 0-.57 1.5l-.04.13-.18.64-.34 1.37-.11.42a7 7 0 0 1-.22.66l-.22.51c-.55 1.3-1.01 1.93-1.62 2.2-.1.04-.22.07-.34.08-1.62.15-3.1.2-4.43.17l-.51-.02a75 75 0 0 1-3.75-.28l-.69-.07.02.03c.32.87.22 1.82-.3 2.56l-.11.16c-.99 1.21-2.82 1.33-4.1.29"
      />
      <path
        fill="red"
        d="m7.42 17.21.47.38 1.32.13c1.81.18 3.24.28 4.29.31 1.29.04 2.72-.02 4.3-.17q.51-.21 1.26-2.1c.3-.76.47-1.87.82-3l.1-.3c.15-.47.4-1.11.75-1.94l-.26-3.33-1.28.11c-1.28.11-1.98.14-2.09.07h-.01v-.02c.07-.33.24-.82.5-1.45l-.36.04a25 25 0 0 0-3.19.6c-.79.22-1.24.46-1.35.73a2.5 2.5 0 0 0-.4-.84c-.14-.2-.84-.8-1.8-2l-.15-.2a26 26 0 0 1-1-1.5L5.36 6.34l.03.9q.105 3.21.42 4.89c.17.87.84 1.7 1.3 2.99.12.38.23 1.08.32 2.1Zm-2.7 3.74c.82.66 1.96.6 2.55-.13.6-.74.41-1.86-.4-2.52l-.13-.1c-.8-.56-1.86-.47-2.42.22-.6.74-.41 1.87.4 2.53"
      />
      <path
        fill="#000"
        d="M8.1 18.21a.5.5 0 0 1-.25-.96l.09-.03c.27-.04 1.18-.58 2.57-1.56l.23-.17c.2-.16.43-.34.71-.6l1.1-.98.13-.11c.44-.39.85-.72 1.27-1.05l.26-.18c.36-.27.85-.59 1.46-.97l1.08-.67.33-2.64a.5.5 0 0 1 .47-.44h.09a.5.5 0 0 1 .43.56l-.36 2.89a.5.5 0 0 1-.23.36l-.8.49c-.98.6-1.7 1.07-2.12 1.4l-.91.73-.44.38-.91.82c-.53.47-.87.75-1.22 1l-.5.34c-1.25.87-2.05 1.32-2.49 1.4Zm-.75-3.67a.5.5 0 0 1-.33-.63c.5-1.65 1-2.86 1.51-3.66.5-.8 1.46-1.84 2.85-3.17a.5.5 0 1 1 .69.73 18.6 18.6 0 0 0-2.7 2.98c-.45.7-.91 1.85-1.4 3.41a.5.5 0 0 1-.62.34m2.75 4.16-.4-.91.46-.2c1.45-.64 2.5-1.15 3.14-1.53s1.54-1 2.68-1.9a.5.5 0 0 1 .78.22l.3.81q.345.87.57 1.35c.2.45.44.88.71 1.3l.28.42-.84.54-.27-.41c-.3-.46-.56-.94-.8-1.43l-.48-1.15-.17-.45-.56.42c-.5.37-.95.68-1.33.92l-.36.22-.34.2q-.93.495-2.58 1.23z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default RedFlag;
